export default __webpack_public_path__ + "static/Supreme-Medium-138bb8f334f7c7032185af215593034a.woff2";